export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SE-71d2ebf81e32a8081b21c817f5831230.png";